import React from 'react';
import { motion } from 'framer-motion';
import { PORTFOLIO_DATA } from '../data/portfolio';
import { Card } from '../components/ui/Card';
import SafeIcon from '../common/SafeIcon';
import { FiTrendingUp, FiUsers, FiBox } from 'react-icons/fi';

export const About = () => {
  const { personal } = PORTFOLIO_DATA;

  return (
    <div className="max-w-4xl mx-auto space-y-16">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">The Journey</h1>
        <div className="prose prose-invert prose-lg text-slate-300">
          <p className="leading-relaxed">
            {personal.about}
          </p>
        </div>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card delay={0.1} hover={false} className="text-center">
          <SafeIcon icon={FiTrendingUp} className="h-8 w-8 text-indigo-400 mx-auto mb-4" />
          <h3 className="text-3xl font-bold text-white mb-1">15+</h3>
          <p className="text-slate-400 text-sm uppercase tracking-wider">Years Experience</p>
        </Card>
        <Card delay={0.2} hover={false} className="text-center">
          <SafeIcon icon={FiBox} className="h-8 w-8 text-cyan-400 mx-auto mb-4" />
          <h3 className="text-3xl font-bold text-white mb-1">10+</h3>
          <p className="text-slate-400 text-sm uppercase tracking-wider">Products Shipped</p>
        </Card>
        <Card delay={0.3} hover={false} className="text-center">
          <SafeIcon icon={FiUsers} className="h-8 w-8 text-purple-400 mx-auto mb-4" />
          <h3 className="text-3xl font-bold text-white mb-1">100k+</h3>
          <p className="text-slate-400 text-sm uppercase tracking-wider">Users Impacted</p>
        </Card>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="bg-gradient-to-r from-indigo-900/40 to-slate-900 border border-indigo-500/20 rounded-2xl p-8 md:p-12"
      >
        <h2 className="text-2xl font-bold text-white mb-4">Why AI for Indie Devs?</h2>
        <p className="text-slate-300 leading-relaxed mb-6">
          In the enterprise world, you have teams of hundreds. In the indie world, you have yourself. 
          AI is the great equalizer. By leveraging LLMs and machine learning, a single developer can 
          now handle ideation, marketing, customer support, and code generation simultaneously. My goal 
          is to build the infrastructure that makes this seamless.
        </p>
        <ul className="space-y-3 text-slate-400">
          <li className="flex items-center">
            <span className="h-2 w-2 bg-indigo-500 rounded-full mr-3"></span>
            Automating mundane tasks to focus on core product value.
          </li>
          <li className="flex items-center">
            <span className="h-2 w-2 bg-indigo-500 rounded-full mr-3"></span>
            Using data-driven AI to validate ideas before building.
          </li>
          <li className="flex items-center">
            <span className="h-2 w-2 bg-indigo-500 rounded-full mr-3"></span>
            Creating intelligent workflows that prevent solo burnout.
          </li>
        </ul>
      </motion.div>
    </div>
  );
};